import React, { HTMLInputTypeAttribute, KeyboardEventHandler, useRef } from 'react'
import styles from './index.module.scss'

interface TextInputProps {
  value?: string
  type?: HTMLInputTypeAttribute
  placeholder?: string
  readonly?: boolean
  disabled?: boolean
  currency?: string | boolean
  onChange?: (value: string) => void
  onEnterPressed?: (value: string) => void
  className?: string
}

export const TextInput: React.FC<TextInputProps> = ({
  type='text',
  value,
  placeholder,
  readonly,
  disabled,
  currency,
  onChange,
  onEnterPressed,
  className,
}) => {
  const input = useRef<HTMLInputElement>(null)

  const handleContainerClick = () => {
    if (input.current) {
      input.current.focus()
    }
  }

  const handleKeyUp: KeyboardEventHandler<HTMLInputElement> = (event) => {
    if (!onEnterPressed) return

    if (event.key === 'Enter') {
      event.preventDefault()

      if (input.current?.value) {
        onEnterPressed(input.current?.value)
      }
    }
  }

  return (
    <div
      className={ `
        ${ className }
        ${ styles['text-input__container'] }
        ${ readonly && styles['text-input__container--read-only'] }
        ${ disabled && styles['text-input__container--disabled'] }
        ${ currency && styles['text-input__container--with-currency'] }
      ` }
      onClick={ handleContainerClick }
    >
      <input
        data-testid="text-input"
        ref={ input }
        type={ type }
        inputMode={ type === 'number' ? 'decimal': 'none' }
        step={ type === 'number' ? 'any' : undefined }
        value={ value }
        placeholder={ placeholder }
        disabled={ disabled }
        readOnly={ readonly }
        className={ styles['text-input__input'] }
        onKeyUp={
          onEnterPressed
            ? handleKeyUp
            : undefined
        }
        onChange={
          onChange
            ? (event) => onChange(event.target.value)
            : undefined
        }
      />

      {
        typeof currency === 'string' &&
          <span className={ styles['text-input__currency'] }>
            { currency }
          </span>
      }
    </div>
  )
}
